export default "__VITE_ASSET__B$uarfW1__"